var map = {
	"./7-eleven.png": 333,
	"./BPI.png": 334,
	"./GCash.png": 335,
	"./GrabPay.png": 336,
	"./PayMaya.png": 337,
	"./coins.ph.png": 338,
	"./dragonpay.png": 339,
	"./fastpay.png": 340,
	"./paycools.png": 341,
	"./paypal.png": 342,
	"./skypay.png": 343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;